import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppService } from '@core/services/app.service';
import { GlobalHandlerService } from '@core/services/global-handler.service';
import { SharedService } from '@core/services/shared.service';
import { CalendarProduct } from '@shared/classes/calendar.model';
import { LocalizedDatePipe } from '../../../shared/pipes/localized-date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingOverlayComponent } from '../../../shared/features/loading-overlay/loading-overlay.component';
import { CalendarViewComponent } from '../calendar-view/calendar-view.component';
import { ImageLoaderDirective } from '../../../shared/directives/image-loader.directive';
import { NgClass } from '@angular/common';
import { SocialShareComponent } from '@shared/components/social-share/social-share.component';

@Component({
    selector: 'app-product-calendar-view',
    templateUrl: './product-calendar-view.component.html',
    styleUrls: ['./product-calendar-view.component.scss'],
    imports: [NgClass, ImageLoaderDirective, CalendarViewComponent, LoadingOverlayComponent, TranslateModule, LocalizedDatePipe,SocialShareComponent]
})
export class ProductCalendarViewComponent implements OnInit {
  private sharedService = inject(SharedService);
  private appService = inject(AppService);
  private globalHandlerService = inject(GlobalHandlerService);
  private route = inject(ActivatedRoute);


  isCustom : boolean;
  calendarProduct : CalendarProduct;
  isLoading : boolean = false;
  eventProgramId : number;
  siteId : number;
    isSmallScreen: boolean = window.innerWidth < 600;


  constructor(){
    this.route.params.subscribe((params:Params)=>{
      this.siteId =+ params['siteId'];
      this.eventProgramId =+ params['eventProgramId'];
    })
  }

  ngOnInit() {
    this.isCustom = this.sharedService.checkRoute();
    this.getCalendarProducts();
  }


  getCalendarProducts(){
    this.isLoading = true;
    let calendarParams = {
      siteId:  this.siteId,
      eventProgramId: this.eventProgramId,
    }
    if(this.isCustom){
      calendarParams["aid"]=  this.sharedService.getCustomAreaIds()
    }

    this.appService.getCalendarProducts(
      'planning/public/sellableproducts/search/findByEventProgramIdAndSiteId',calendarParams).subscribe((response:CalendarProduct)=>{
        this.calendarProduct = response;
        this.isLoading = false;
      },
      (error)=>{
        this.isLoading = false;
        this.globalHandlerService.showError(error);

      })
  }

  onShareEvent(){
    if (navigator.share) {
       navigator.share({
        url: window.location.href,
      })  
    } 
  }
}

